export default "__VITE_ASSET__Cm34R3SI__"